(function () {
  var root = document.getElementById('ce-up-consent');
  var openBtn = document.getElementById('ce-up-consent-open');
  if (!root || root.getAttribute('data-init')) return;
  root.setAttribute('data-init', '1');
  var KEY = 'ce_consent_v1', lastFocus = null;
  var views = { main: root.querySelector('[data-view=main]'), settings: root.querySelector('[data-view=settings]') };
  var boxes = root.querySelectorAll('input[data-cat]');
  function read() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  /* Der schwebende Button bleibt immer versteckt. Zugang zu den Einstellungen: Link im Footer. */
  if (openBtn) openBtn.hidden = true;
  function footerLink() {
    if (document.querySelector('a[data-ce-open-consent]')) return;
    var a = document.querySelector('.shopify-section-group-footer-group a[href*="privacy-policy"]');
    var li = a && a.closest('li');
    if (!li || !li.parentNode) return;
    var n = li.cloneNode(true), l = n.querySelector('a');
    if (!l) return;
    l.textContent = 'Cookie-Einstellungen';
    l.setAttribute('href', '#cookie-einstellungen');
    l.setAttribute('data-ce-open-consent', '');
    li.parentNode.appendChild(n);
  }
  function show(v) {
    views.main.hidden = v !== 'main'; views.settings.hidden = v !== 'settings';
    var t = views[v].querySelector('.ceu-c__title'); if (t) t.focus({ preventScroll: true });
  }
  function open(v) {
    lastFocus = document.activeElement;
    var s = read() || {};
    for (var i = 0; i < boxes.length; i++) boxes[i].checked = !!s[boxes[i].getAttribute('data-cat')];
    root.hidden = false; show(v || 'main');
    window.requestAnimationFrame(function () { root.setAttribute('data-state', 'open'); });
    document.documentElement.setAttribute('data-ce-consent-open', '1');
  }
  function close() {
    root.setAttribute('data-state', 'closed'); root.hidden = true;
    document.documentElement.removeAttribute('data-ce-consent-open');
    document.dispatchEvent(new CustomEvent('ce-consent-closed'));
    if (lastFocus && lastFocus.focus && document.contains(lastFocus) && lastFocus !== document.body) { lastFocus.focus(); }
  }
  function decide(c) {
    c.t = new Date().toISOString(); write(c);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ce_consent_update', ce_consent: { analytics: c.analytics, marketing: c.marketing, preferences: c.preferences } }); } catch (e) {}
    if (window.ceConsentApply) window.ceConsentApply(c);
    close();
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ceu]'); if (!b) return;
    var a = b.getAttribute('data-ceu');
    if (a === 'accept') decide({ analytics: true, marketing: true, preferences: true });
    else if (a === 'reject') decide({ analytics: false, marketing: false, preferences: false });
    else if (a === 'settings') show('settings');
    else if (a === 'back') show('main');
    else if (a === 'save') {
      var c = { analytics: false, marketing: false, preferences: false };
      for (var i = 0; i < boxes.length; i++) c[boxes[i].getAttribute('data-cat')] = boxes[i].checked;
      decide(c);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden && !views.settings.hidden) { e.preventDefault(); show('main'); }
  });
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('a[href*="cookie-einstellungen"],[data-ce-open-consent]');
    if (l) { e.preventDefault(); open('settings'); }
  });
  footerLink();
  var saved = read();
  if (saved) {
    if (window.ceConsentApply) window.ceConsentApply(saved); /* Entscheidung bei jedem Besuch an Shopify melden */
  } else {
    setTimeout(function () { open('main'); }, 400);
  }
})();
